import { ILaya } from "../../ILaya";
import { Pool } from "../utils/Pool";
import { Ease } from "./Ease";
import { TweenValue, TweenValueAdapterKey } from "./TweenValue";
export class Tweener {
    static create(owner) {
        let tweener = Tweener._pool.take();
        _activeTweens[_totalActiveTweens++] = tweener;
        tweener.owner = owner;
        return tweener;
    }
    static getTween(id) {
        return _activeTweenMap.get(id);
    }
    static isTweening(target) {
        if (target == null)
            return false;
        for (let i = 0; i < _totalActiveTweens; i++) {
            let tweener = _activeTweens[i];
            if (tweener && tweener.target == target && !tweener._killed)
                return true;
        }
        return false;
    }
    static getTweens(target, out) {
        out = out || [];
        if (target == null)
            return out;
        let cnt = _totalActiveTweens;
        for (let i = 0; i < cnt; i++) {
            let tweener = _activeTweens[i];
            if (tweener && tweener.target == target && !tweener._killed) {
                out.push(tweener.owner);
            }
        }
        return out;
    }
    static kill(tweenId, complete) {
        let tween = _activeTweenMap.get(tweenId);
        if (!tween || tween._killed)
            return false;
        tween.kill(complete);
        return true;
    }
    static killAll(target, completed) {
        if (target == null)
            return false;
        let flag = false;
        let cnt = _totalActiveTweens;
        for (let i = 0; i < cnt; i++) {
            let tweener = _activeTweens[i];
            if (tweener && tweener.target == target && !tweener._killed) {
                tweener.kill(completed);
                flag = true;
            }
        }
        return flag;
    }
    constructor() {
        this.props = [];
        this.easeArgs = [];
        this.interpArgs = [];
        this.startValue = new TweenValue(this.props);
        this.endValue = new TweenValue(this.props);
        this.value = new TweenValue(this.props);
        this.deltaValue = new TweenValue(this.props);
    }
    go(propName, startValue, endValue) {
        let prop = _propsPool.take();
        this.props.push(prop);
        prop.name = propName;
        prop.offset = this.startValue.nums.length;
        if (this._active) {
            prop.renewFlags = 0;
            if (startValue === undefined)
                startValue = this.target[propName];
            if (endValue === undefined)
                endValue = this.target[propName];
        }
        else
            prop.renewFlags = startValue === undefined ? 1 : endValue === undefined ? 2 : 0;
        const type = startValue != null ? typeof (startValue) : typeof (endValue);
        let adapter;
        if (type === "number")
            prop.type = 0;
        else if (type === "string")
            prop.type = 2;
        else if (type == "object" && (adapter = startValue[TweenValueAdapterKey]) != null)
            prop.type = adapter;
        else
            prop.type = 1;
        this.startValue.write(prop.type, prop.offset, startValue !== undefined ? startValue : endValue);
        this.endValue.write(prop.type, prop.offset, endValue !== undefined ? endValue : startValue);
        return this;
    }
    get normalizedTime() {
        return this._normalizedTime;
    }
    get breaking() {
        return this._ended == 1;
    }
    get remainTime() {
        if (this.breakpoint >= 0)
            return this.delay + this.breakpoint - this._elapsedTime;
        else if (this.repeat >= 0)
            return this.delay + this.duration * (this.repeat + 1) - this._elapsedTime;
        else
            return this.delay + this.duration * 2 - this._elapsedTime;
    }
    activate() {
        this._active = true;
        this._startFrame = ILaya.timer.currFrame;
        for (let prop of this.props) {
            if (prop.renewFlags == 1)
                this.startValue.write(prop.type, prop.offset, this.target[prop.name]);
            else if (prop.renewFlags == 2)
                this.endValue.write(prop.type, prop.offset, this.target[prop.name]);
        }
    }
    seek(time) {
        if (this._killed)
            return;
        this._elapsedTime = time;
        if (this._elapsedTime < this.delay) {
            if (this._started)
                this._elapsedTime = this.delay;
            else
                return;
        }
        this.update2();
    }
    kill(complete) {
        if (this._killed)
            return;
        if (complete) {
            if (this._ended == 0) {
                this._elapsedTime = 0;
                this._elapsedTime = this.remainTime;
                this.update2();
            }
            this.callCompleteCallback();
        }
        else if (this.onCompleteResolvers)
            this.onCompleteResolvers.forEach(f => f());
        this._killed = true;
    }
    init() {
        _idCounter++;
        if (_idCounter < 1)
            _idCounter = 1;
        this.id = _idCounter;
        _activeTweenMap.set(this.id, this);
        this.name = null;
        this.delay = 0;
        this.duration = 0;
        this.breakpoint = -1;
        this.startValue.nums.length = 0;
        this.endValue.nums.length = 0;
        this.value.nums.length = 0;
        this.ease = Ease.linear;
        this.easeArgs.length = 0;
        this.timeScale = 1;
        this.snapping = false;
        this.repeat = 0;
        this.yoyo = false;
        this.interp = null;
        this.interpArgs.length = 0;
        this._started = false;
        this.paused = false;
        this._killed = false;
        this._startFrame = ILaya.timer.currFrame;
        this._elapsedTime = 0;
        this._normalizedTime = 0;
        this._ended = 0;
        this._active = false;
    }
    reset() {
        this.id = -1;
        this.owner = null;
        this.target = null;
        this.lifecycleOwner = null;
        this.userData = null;
        _propsPool.recover(this.props);
        this.onStart = this.onUpdate = this.onComplete = this.onCompleteResolvers = null;
        this.onStartCaller = this.onUpdateCaller = this.onCompleteCaller = null;
    }
    update(dt) {
        if (this.timeScale != 1)
            dt *= this.timeScale;
        if (dt == 0)
            return;
        if (this._ended != 0) {
            this.callCompleteCallback();
            this._killed = true;
            return;
        }
        this._elapsedTime += dt;
        this.update2();
        if (this._ended != 0) {
            if (!this._killed) {
                this.callCompleteCallback();
                this._killed = true;
            }
        }
    }
    update2() {
        this._ended = 0;
        if (!this._started) {
            if (this._elapsedTime < this.delay)
                return;
            this._started = true;
            this.value.copy(this.startValue);
            this.deltaValue.nums.length = this.startValue.nums.length;
            this.deltaValue.nums.fill(0);
            this.callStartCallback();
            if (this._killed)
                return;
        }
        let reversed = false;
        let dur = this.duration;
        let tt = this._elapsedTime - this.delay;
        if (this.breakpoint >= 0 && tt >= this.breakpoint) {
            tt = this.breakpoint;
            this._ended = 2;
        }
        if (this.repeat != 0) {
            let round = Math.floor(tt / dur);
            tt -= dur * round;
            if (this.yoyo)
                reversed = round % 2 == 1;
            if (this.repeat > 0 && this.repeat - round < 0) {
                if (this.yoyo)
                    reversed = this.repeat % 2 == 1;
                tt = dur;
                this._ended = 1;
            }
        }
        else if (tt >= dur) {
            tt = dur;
            this._ended = 1;
        }
        let t = dur > 0 ? this.ease(reversed ? (dur - tt) : tt, 0, 1, dur, ...this.easeArgs) : 1;
        this._normalizedTime = t;
        let startNums = this.startValue.nums;
        let endNums = this.endValue.nums;
        let valueNums = this.value.nums;
        let deltaNums = this.deltaValue.nums;
        valueNums.fill(0);
        deltaNums.fill(0);
        if (this.interp) {
            this.interp(t, startNums, endNums, valueNums, ...this.interpArgs);
            for (let i = 0, n = startNums.length; i < n; i++) {
                let f = valueNums[i];
                if (this.snapping)
                    f = Math.round(f);
                deltaNums[i] = f - valueNums[i];
            }
        }
        else {
            for (let i = 0, n = startNums.length; i < n; i++) {
                let n1 = startNums[i];
                let n2 = endNums[i];
                let f = n1 + (n2 - n1) * t;
                if (this.snapping)
                    f = Math.round(f);
                deltaNums[i] = f - valueNums[i];
                valueNums[i] = f;
            }
        }
        if (this.target != null) {
            for (let prop of this.props) {
                if (prop.name) {
                    let v = prop.type === 1 ? (this._ended === 1 ? this.endValue.read(prop.type, prop.offset)
                        : this.startValue.read(prop.type, prop.offset))
                        : this.value.read(prop.type, prop.offset);
                    if ((prop.type === 0 || prop.type === 1 || prop.type === 2)
                        && this.target[prop.name] === v)
                        continue;
                    this.target[prop.name] = v;
                }
            }
        }
        this.callUpdateCallback();
    }
    callStartCallback() {
        if (this.onStart) {
            try {
                this.onStart.call(this.onStartCaller, this);
            }
            catch (err) {
                console.error("error in start callback > ", err);
            }
        }
    }
    callUpdateCallback() {
        if (this.onUpdate) {
            try {
                this.onUpdate.call(this.onUpdateCaller, this);
            }
            catch (err) {
                console.error("error in update callback > ", err);
            }
        }
    }
    callCompleteCallback() {
        if (this.onComplete) {
            try {
                this.onComplete.call(this.onCompleteCaller, this);
            }
            catch (err) {
                console.error("error in complete callback > ", err);
            }
        }
        if (this.onCompleteResolvers)
            this.onCompleteResolvers.forEach(f => f());
    }
    static _runAll() {
        var _a;
        let cnt = _totalActiveTweens;
        if (cnt == 0)
            return;
        let frame = ILaya.timer.currFrame;
        let dt = ILaya.timer.delta;
        let udt = ILaya.timer.unscaledDelta;
        let freePosStart = -1;
        for (let i = 0; i < cnt; i++) {
            let tweener = _activeTweens[i];
            if (tweener == null) {
                if (freePosStart == -1)
                    freePosStart = i;
            }
            else if (tweener._killed) {
                _activeTweenMap.delete(tweener.id);
                (_a = tweener.owner) === null || _a === void 0 ? void 0 : _a._check();
                Tweener._pool.recover(tweener);
                _activeTweens[i] = null;
                if (freePosStart == -1)
                    freePosStart = i;
            }
            else {
                if (tweener.target && tweener.target.destroyed
                    || tweener.lifecycleOwner && tweener.lifecycleOwner.destroyed)
                    tweener._killed = true;
                else if (!tweener.paused && tweener._active)
                    tweener.update(tweener._startFrame == frame ? 0 : tweener.ignoreEngineTimeScale ? udt : dt);
                if (freePosStart != -1) {
                    _activeTweens[freePosStart] = tweener;
                    _activeTweens[i] = null;
                    freePosStart++;
                }
            }
        }
        if (freePosStart >= 0) {
            if (_totalActiveTweens != cnt) {
                let j = cnt;
                cnt = _totalActiveTweens - cnt;
                for (let i = 0; i < cnt; i++) {
                    _activeTweens[freePosStart++] = _activeTweens[j];
                    _activeTweens[j] = null;
                    j++;
                }
            }
            _totalActiveTweens = freePosStart;
        }
    }
    static _getMap() {
        return _activeTweenMap;
    }
}
Tweener._pool = Pool.createPool(Tweener, e => e.init(), e => e.reset());
var _idCounter = 0;
var _totalActiveTweens = 0;
const _activeTweens = [];
const _activeTweenMap = new Map();
const _propsPool = Pool.createPool(Object);
